import React from "react";

const AdminIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.86"
      height="25.502"
      viewBox="0 0 24.86 25.502"
    >
      <g id="db5" transform="translate(-4.423 -3.761)">
        <path
          id="Path_1153"
          data-name="Path 1153"
          d="M22.4,9.858a.385.385,0,0,0-.195-.131,1.758,1.758,0,0,0,.06-.675,1.37,1.37,0,0,1,.112-.391.928.928,0,0,0,.118-.5,1.067,1.067,0,0,0,0-.216c-.054-2.32-2.252-4.187-4.961-4.187-2.742,0-4.965,1.914-4.965,4.275,0,.079,0,.145.005.206l-.005.009.007.026c.012.194.043.3.093.327.089.3.073.756.135,1.149h0a.361.361,0,0,0-.134.106c-.152.206-.087.655-.087.966a1.036,1.036,0,0,0,.847,1.141c.592,2.266,2.2,3.895,4.105,3.895s3.514-1.629,4.106-3.895a1.036,1.036,0,0,0,.847-1.141C22.486,10.513,22.55,10.064,22.4,9.858Z"
          transform="translate(-4.186 0)"
          fill={fill ? fill : "#000"}
        />
        <path
          id="Path_1154"
          data-name="Path 1154"
          d="M40.789,32.542V25.376H31.114v6.773H26.807v7.166h3.34v.677H29.078v.381h5.134v-.381H33.2v-.677h3.281V33.6h2.036V33.22H37.507v-.678Zm-4.774,6.306H27.275v-6.3h7.179v.67H33.385V33.6h2.631v5.247Zm-4.434-6.773v-6.3h8.741v6.3Z"
          transform="translate(-11.506 -11.111)"
          fill={fill ? fill : "#000"}
        />
        <rect
          id="Rectangle_3402"
          data-name="Rectangle 3402"
          width="7.179"
          height="5.05"
          transform="translate(20.856 15.29)"
          fill={fill ? fill : "#000"}
        />
        <path
          id="Path_1155"
          data-name="Path 1155"
          d="M19.12,29.047a12.228,12.228,0,0,0-2.812-.815A30.575,30.575,0,0,0,13.317,31.9v.02a.184.184,0,0,1-.022-.01.125.125,0,0,1-.022.01V31.9a20.151,20.151,0,0,0-2.961-3.644A10.73,10.73,0,0,0,4.441,31.2c-.077,1.6.076,3.741.763,4.658.619.826,1.674,2.395,6.46,2.7a19.648,19.648,0,0,0,2.8.048V32.982h4.659V29.047Z"
          transform="translate(0 -12.579)"
          fill={fill ? fill : "#000"}
        />
      </g>
    </svg>
  );
};

export default AdminIcon;
